/**
 * @desc textAlgin
 */
import { bboxIntersect } from '@byted/light-render/lib/utils/bbox';
import { normalizeAngle, getPolar, degToRad } from './math';
export function getCircleLayoutLabelAlign(angle, inside) {
    if (inside === void 0) { inside = false; }
    var nAngle = normalizeAngle(angle);
    var textAlign = 'center';
    var textBaseline = 'middle';
    if ((nAngle >= 0 && nAngle < 90) || (nAngle > 270 && nAngle < 360)) {
        textAlign = inside ? 'right' : 'left';
    }
    else {
        // left
        textAlign = inside ? 'left' : 'right';
    }
    if (nAngle > 0 && nAngle < 180) {
        // bottom
        textBaseline = inside ? 'bottom' : 'top';
    }
    else {
        // top
        textBaseline = inside ? 'top' : 'bottom';
    }
    if (nAngle === 0 || nAngle === 180) {
        textBaseline = 'middle';
    }
    else if (nAngle === 90 || nAngle === 270) {
        textAlign = 'center';
    }
    return {
        textAlign: textAlign,
        textBaseline: textBaseline,
    };
}
export function getSlopeLayoutTextAlign(angle, inside) {
    if (inside === void 0) { inside = false; }
    var nAngle = normalizeAngle(angle);
    var textAlign = 'center';
    var textBaseline = 'middle';
    if ((nAngle > 0 && nAngle < 90) || (nAngle > 270 && nAngle < 360)) {
        // right
        textBaseline = inside ? 'top' : 'bottom';
    }
    else {
        // left
        textBaseline = inside ? 'bottom' : 'top';
    }
    if (nAngle > 0 && nAngle < 180) {
        // bottom
        textAlign = inside ? 'right' : 'left';
    }
    else {
        // up
        textAlign = inside ? 'left' : 'right';
    }
    if (nAngle === 0 || nAngle === 180) {
        textAlign = 'center';
    }
    else if (nAngle === 90 || nAngle === 270) {
        textBaseline = 'middle';
    }
    return {
        textAlign: textAlign,
        textBaseline: textBaseline,
    };
}
export function getBoxLabelPosition(box, position, distance, direction) {
    var x = box.x, y = box.y, width = box.width, height = box.height;
    var left = Math.min(x, x + width);
    var right = Math.max(x, x + width);
    var top = Math.min(y, y + height);
    var bottom = Math.max(y, y + height);
    return getRectLabelPosition({ left: left, right: right, top: top, bottom: bottom }, position, distance, direction);
}
/**
 *
 * @param box clientBox of rect
 * @param position text positon option
 * @param distance text distance
 * @param direction bar grow dirction
 */
export function getRectLabelPosition(box, rposition, distance, direction) {
    if (direction === void 0) { direction = 'top'; }
    var top = box.top, left = box.left, right = box.right, bottom = box.bottom;
    var cx = (left + right) / 2;
    var cy = (top + bottom) / 2;
    var insideTop = top + distance;
    var insideLeft = left + distance;
    var insideRight = right - distance;
    var insideBottom = bottom - distance;
    var outsideTop = top - distance;
    var outsideLeft = left - distance;
    var outsideRight = right + distance;
    var outsideBottom = bottom + distance;
    var position = rposition;
    if (position === 'outside') {
        position = direction;
    }
    else if (position === 'insideStart') {
        var directionMap = {
            top: 'insideBottom',
            bottom: 'insideTop',
            left: 'insideRight',
            right: 'insideLeft',
        };
        position = directionMap[direction];
    }
    else if (position === 'insideEnd') {
        var directionMap = {
            top: 'insideTop',
            bottom: 'insideBottom',
            left: 'insideLeft',
            right: 'insideRight',
        };
        position = directionMap[direction];
    }
    var positionMap = {
        top: {
            x: cx,
            y: outsideTop,
            textAlign: 'center',
            textBaseline: 'bottom',
        },
        topStart: {
            x: left,
            y: outsideTop,
            textAlign: 'left',
            textBaseline: 'bottom',
        },
        topEnd: {
            x: right,
            y: outsideTop,
            textAlign: 'right',
            textBaseline: 'bottom',
        },
        left: {
            x: outsideLeft,
            y: cy,
            textAlign: 'right',
            textBaseline: 'middle',
        },
        leftStart: {
            x: outsideLeft,
            y: top,
            textAlign: 'right',
            textBaseline: 'top',
        },
        leftEnd: {
            x: outsideLeft,
            y: bottom,
            textAlign: 'right',
            textBaseline: 'bottom',
        },
        right: {
            x: outsideRight,
            y: cy,
            textAlign: 'left',
            textBaseline: 'middle',
        },
        rightStart: {
            x: outsideRight,
            y: top,
            textAlign: 'left',
            textBaseline: 'top',
        },
        rightEnd: {
            x: outsideRight,
            y: bottom,
            textAlign: 'left',
            textBaseline: 'bottom',
        },
        bottom: {
            x: cx,
            y: outsideBottom,
            textAlign: 'center',
            textBaseline: 'top',
        },
        bottomStart: {
            x: left,
            y: outsideBottom,
            textAlign: 'left',
            textBaseline: 'top',
        },
        bottomEnd: {
            x: right,
            y: outsideBottom,
            textAlign: 'right',
            textBaseline: 'top',
        },
        insideTop: {
            x: cx,
            y: insideTop,
            textAlign: 'center',
            textBaseline: 'top',
        },
        insideLeft: {
            x: insideLeft,
            y: cy,
            textAlign: 'left',
            textBaseline: 'middle',
        },
        insideRight: {
            x: insideRight,
            y: cy,
            textAlign: 'right',
            textBaseline: 'middle',
        },
        insideBottom: {
            x: cx,
            y: insideBottom,
            textAlign: 'center',
            textBaseline: 'bottom',
        },
    };
    return (positionMap[position] || {
        x: cx,
        y: cy,
        textAlign: 'center',
        textBaseline: 'middle',
    });
}
/**
 *
 * @param sector sector param
 * @param position text position
 * @param distance text margin
 * @param direction sector grow direction
 */
export function getSectorLabelPosition(sector, position, distance, direction, rotate) {
    if (direction === void 0) { direction = 'radius'; }
    if (rotate === void 0) { rotate = 0; }
    var cx = sector.cx, cy = sector.cy, startAngle = sector.startAngle, endAngle = sector.endAngle, radius = sector.radius, innerRadius = sector.innerRadius;
    var midAngle = (startAngle + endAngle) / 2;
    var midRadius = (innerRadius + radius) / 2;
    var rotation = 0;
    if (typeof rotate === 'number') {
        rotation = degToRad(rotate);
    }
    if (rotate === 'radial') {
        rotation = degToRad(getTextRotation(midAngle));
    }
    if (rotate === 'tangential') {
        rotation = degToRad(getTextRotation(midAngle + 90));
    }
    var getPoint = getPolar(sector);
    if (position === 'center') {
        return {
            x: cx,
            y: cy,
            textAlign: 'center',
            textBaseline: 'middle',
        };
    }
    if (position === 'inside') {
        var _a = getPoint(midAngle, midRadius), x = _a.x, y = _a.y;
        return {
            x: x,
            y: y,
            textAlign: 'center',
            textBaseline: 'middle',
            originX: x,
            originY: y,
            rotation: rotation,
        };
    }
    if (position === 'outside') {
        if (direction === 'radius' || direction === 'innerRadius') {
            var _b = getPoint(midAngle, Math.max(radius, innerRadius) + distance), x = _b.x, y = _b.y;
            var _c = getCircleLayoutLabelAlign(midAngle, false), textAlign = _c.textAlign, textBaseline = _c.textBaseline;
            return {
                x: x,
                y: y,
                textAlign: rotate === 'tangential' ? 'center' : textAlign,
                textBaseline: textBaseline,
                originX: x,
                originY: y,
                rotation: rotation,
            };
        }
        if (direction === 'startAngle' || direction === 'endAngle') {
            var _d = getPoint(endAngle, midRadius), x = _d.x, y = _d.y;
            var dx = distance * Math.cos(degToRad(endAngle + 90));
            var dy = distance * Math.sin(degToRad(endAngle + 90));
            // const {textAlign, textBaseline, } = getSlopeLayoutTextAlign(endAngle, true);
            return {
                x: x + dx,
                y: y + dy,
                textAlign: 'center',
                textBaseline: 'middle',
                originX: x,
                originY: y,
                rotation: rotation,
            };
        }
    }
    else if (position === 'insideStart') {
        if (direction === 'radius' || direction === 'innerRadius') {
            var _e = getPoint(midAngle, Math.min(radius, innerRadius) + distance), x = _e.x, y = _e.y;
            var _f = getCircleLayoutLabelAlign(midAngle, false), textAlign = _f.textAlign, textBaseline = _f.textBaseline;
            return {
                x: x,
                y: y,
                textAlign: textAlign,
                textBaseline: textBaseline,
            };
        }
        if (direction === 'startAngle' || direction === 'endAngle') {
            var _g = getPoint(startAngle, midRadius), x = _g.x, y = _g.y;
            var dx = distance * Math.cos(degToRad(startAngle + 90));
            var dy = distance * Math.sin(degToRad(startAngle + 90));
            var _h = getSlopeLayoutTextAlign(startAngle, true), textAlign = _h.textAlign, textBaseline = _h.textBaseline;
            return {
                x: x + dx,
                y: y + dy,
                textAlign: textAlign,
                textBaseline: textBaseline,
            };
        }
    }
    else if (position === 'insideEnd') {
        if (direction === 'radius' || direction === 'innerRadius') {
            var _j = getPoint(midAngle, Math.max(radius, innerRadius) - distance), x = _j.x, y = _j.y;
            var _k = getCircleLayoutLabelAlign(midAngle, true), textAlign = _k.textAlign, textBaseline = _k.textBaseline;
            return {
                x: x,
                y: y,
                textAlign: textAlign,
                textBaseline: textBaseline,
            };
        }
        if (direction === 'startAngle' || direction === 'endAngle') {
            var _l = getPoint(endAngle, midRadius), x = _l.x, y = _l.y;
            var dx = distance * Math.cos(degToRad(endAngle - 90));
            var dy = distance * Math.sin(degToRad(endAngle - 90));
            return {
                x: x + dx,
                y: y + dy,
                textAlign: 'center',
                textBaseline: 'middle',
            };
        }
    }
    else {
        var _m = getPoint(midAngle, midRadius), x = _m.x, y = _m.y;
        return {
            x: x,
            y: y,
            textAlign: 'center',
            textBaseline: 'middle',
        };
    }
}
export function autoHideLabels(labelList) {
    var visibleBBox = [];
    var _loop_1 = function (i) {
        var label = labelList[i];
        if (!label) {
            return "continue";
        }
        var bbox = label.getBoundingClientRect();
        var isHit = visibleBBox.some(function (existVisibleBBox) { return bboxIntersect(existVisibleBBox, bbox); });
        if (!isHit) {
            visibleBBox.push(bbox);
        }
        else {
            label.setAttr('display', false);
        }
    };
    for (var i = 0; i < labelList.length; i++) {
        _loop_1(i);
    }
    visibleBBox.length = 0;
}
export function getTextRotation(angle) {
    var hside = getAngleHorizontalSide(angle);
    return hside === 'right' ? angle : angle + 180;
}
export function getAngleHorizontalSide(angle) {
    var nAngle = normalizeAngle(angle);
    if ((nAngle >= 0 && nAngle <= 90) || (nAngle >= 270 && nAngle <= 360)) {
        return 'right';
    }
    return 'left';
}
export function getAngleVerticalSide(angle) {
    var nAngle = normalizeAngle(angle);
    if (nAngle >= 0 && nAngle <= 180) {
        return 'bottom';
    }
    return 'top';
}
